(function () {
    'use strict';

    angular.module('NaviaqWebApp').controller('customersUnitAgreementModalController', customersUnitAgreementModalController);

    customersUnitAgreementModalController.$inject = [
        '$translate',
        '$rootScope',
        '$scope',
        '$windowInstance',
        'customerUnitAgreement',
        'currentFormType',
        'formTypes',
        'customerService',
        'htmlElementService',
        'customerId',
        'units',
        'dateUtility'
    ];

    function customersUnitAgreementModalController(
        $translate,
        $rootScope,
        $scope,
        $windowInstance,
        customerUnitAgreement,
        currentFormType,
        formTypes,
        customerService,
        htmlElementService,
        customerId,
        units,
        dateUtility
    ) {
        $scope.customerUnitAgreement = {};
        $scope.close = close;
        $scope.validateForm = validateForm;
        $scope.triggerValidation = triggerValidation;
        $scope.selectedUnit = null;

        $scope.unitOptions = {
            dataSource: new kendo.data.DataSource({
                data: units,
                sort: { field: 'description', dir: 'asc' }
            }),
            dataValueField: 'id',
            dataTextField: 'description',
            optionLabel: $translate.instant('ADMIN_CUSTOMERS_SELECT_UNIT')
        };

        $scope.toDatePickerOptions = {};

        // Define validator options for Kendo Validator
        $scope.validatorOptions = {
            rules: {
                ensureToDateIsAfterOrEqualToFromDate: function(input) {
                    if (input.is("[id='to-date-picker']") || input.is("[id='from-date-picker']")) {
                        const fromDateString = $('#from-date-picker').val();
                        const toDateString = $('#to-date-picker').val();

                        const fromDate = kendo.parseDate(fromDateString, "dd.MM.yyyy");
                        const toDate = kendo.parseDate(toDateString, "dd.MM.yyyy");

                        // If either date is not properly entered/parsed,
                        // let other validators (like 'required') handle it.
                        if (!fromDate || !toDate) {
                            return true;
                        }

                        // Clear time part for accurate day-to-day comparison
                        const fromDay = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
                        const toDay = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());

                        return toDay >= fromDay;
                    }
                    return true;
                }
            },
            messages: {
                ensureToDateIsAfterOrEqualToFromDate: $translate.instant('ADMIN_CUSTOMERS_UNIT_AGREEMENT_DATE_BEFORE_AFTER')
            },
            validateOnBlur: true
        };

        initController();

        function initController() {
            htmlElementService.checkIfElementExists("customer-detatails-form")
                .then(function (result) {
                    $rootScope.$broadcast('showBusyIndicator', {
                        id: 'customersUnitAgreementIndicator',
                        destination: '#customer-detatails-form',
                        overlay: true
                    });

                    if (currentFormType === formTypes.edit && customerUnitAgreement) {
                        $scope.customerUnitAgreement = angular.copy(customerUnitAgreement);
                    }

                    $scope.selectedUnit = units.find(function (unit) {
                        return unit.id == $scope.customerUnitAgreement.unitId;
                    });

                    $rootScope.$broadcast('hideBusyIndicator', 'customersUnitAgreementIndicator');
                });
        }

        function validateForm(event) {
            event.preventDefault();

            const validator = $("#customer-detatails-form").data("kendoValidator");
            if (validator.validate()) {
                $rootScope.$broadcast('showBusyIndicator', {
                    id: 'customersUnitAgreementIndicator',
                    destination: '#customer-detatails-form',
                    overlay: true
                });

                switch (currentFormType) {
                    case formTypes.add:
                        $scope.customerUnitAgreement.customerId = customerId;
                        $scope.customerUnitAgreement.unitId = $scope.selectedUnit.id;
                        $scope.customerUnitAgreement.unit = null;
                        $scope.customerUnitAgreement.fromDate = dateUtility.toIsoString($scope.customerUnitAgreement.fromDate);
                        $scope.customerUnitAgreement.toDate = dateUtility.toIsoString($scope.customerUnitAgreement.toDate);
                        $scope.customerUnitAgreement.comment = $scope.customerUnitAgreement.comment || '';
                        customerService.addCustomerUnitAgreement($scope.customerUnitAgreement)
                            .then(customerUnitAgreementResult => close(customerUnitAgreementResult))
                            .catch(() => close());
                        break;
                    case formTypes.edit:
                        $scope.customerUnitAgreement.unitId = $scope.selectedUnit.id;
                        $scope.customerUnitAgreement.unit = null;
                        $scope.customerUnitAgreement.fromDate = dateUtility.toIsoString($scope.customerUnitAgreement.fromDate);
                        $scope.customerUnitAgreement.toDate = dateUtility.toIsoString($scope.customerUnitAgreement.toDate);
                        $scope.customerUnitAgreement.comment = $scope.customerUnitAgreement.comment || '';
                        customerService.updateCustomerUnitAgreement($scope.customerUnitAgreement)
                            .then(customerUnitAgreementResult => close(customerUnitAgreementResult))
                            .catch(() => close());
                        break;
                    default:
                        close();
                        break;
                }
            }
        }

        function triggerValidation() {
            const validator = $("#customer-detatails-form").data("kendoValidator");
            if (validator) {
                validator.validate();
            }
        }

        function close(param) {
            $rootScope.$broadcast('hideBusyIndicator', 'customersUnitAgreementIndicator');
            $windowInstance.close(param);
        }
    }
})();
